import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthorizationGuardService } from '../../shared/libs/auth/authorization-guard.service';
import { CompanyRole } from '../../models/shared/enums/company-role.enum';
import { SidenavTypeEnum } from '../../shared/models/sidebar-group.models';
import { CompanyComponent } from './components/company.component';
import { CompanyOrderListComponent } from './components/company-order-list/company-order-list.component';
import { CompanyPhotographerDetailComponent } from './components/company-photographer-detail/company-photographer-detail.component';
import { CompanyStyleDetailComponent } from './components/company-style-detail/company-style-detail.component';
import { CompanyStyleListComponent } from './components/company-style-list/company-style-list.component';
import { CompanyOrderDetailComponent } from './components/company-order-detail/company-order-detail.component';
import { CompanyOrderDetailInfoComponent } from './components/company-order-detail/company-order-detail-info/company-order-detail-info.component';
import { CompanyOrderDetailShotsComponent } from './components/company-order-detail/company-order-detail-shots/company-order-detail-shots.component';
import { CompanyPhotographerListComponent } from './components/company-photographer-list/company-photographer-list.component';
import { CompanyTemplateListComponent } from './components/company-template-list/company-template-list.component';
import { CompanyTemplateDetailComponent } from './components/company-template-detail/company-template-detail.component';

const routes: Routes = [
	{
		path: '',
		component: CompanyComponent,
		data: { sidenavType: SidenavTypeEnum.company },
		children: [
			{
				path: '',
				redirectTo: 'order-list',
				pathMatch: 'full'
			},
			// {
			// 	path: 'dashboard',
			// 	component: CompanyDashboardComponent,
			// 	data: { title: 'Dashboard | Company | BasicStudios', roles: [CompanyRole.DASHBOARD_READ] },
			// 	canActivate: [AuthorizationGuardService]
			// },
			{
				path: 'order-info',
				redirectTo: 'order-list',
				pathMatch: 'full'
			},
			{
				path: 'order-info/order-detail-info/:orderId',
				redirectTo: 'order-view/:orderId/order-detail-info',
				pathMatch: 'full'
			},
			{
				path: 'order-info/order-detail-shots/:orderId',
				redirectTo: 'order-view/:orderId/order-detail-shots',
				pathMatch: 'full'
			},
			{
				path: 'order-list',
				component: CompanyOrderListComponent,
				data: { title: 'Order list | Company | BasicStudios', roles: [CompanyRole.ORDERLIST_READ] },
				canActivate: [AuthorizationGuardService]
			},

			{
				path: 'order-view',
				redirectTo: 'order-view/new',
				pathMatch: 'full'
			},
			{
				path: 'order-view/:orderId',
				component: CompanyOrderDetailComponent,
				data: { title: 'Order | Company | BasicStudios', roles: [CompanyRole.ORDERLIST_READ, CompanyRole.ORDERLIST_EDIT] },
				canActivate: [AuthorizationGuardService],
				children: [
					{
						path: '',
						redirectTo: 'order-detail-info',
						pathMatch: 'full'
					},
					{
						path: 'order-detail-info',
						component: CompanyOrderDetailInfoComponent
					},
					{
						path: 'order-detail-shots',
						component: CompanyOrderDetailShotsComponent
					}
				]
			},

			//OLD FORM
			// {
			// 	path: 'new-order',
			// 	component: OrderFormComponent,
			// 	data: { title: 'New Order | Company | BasicStudios', roles: [CompanyRole.ORDERLIST_EDIT] },
			// 	canActivate: [AuthorizationGuardService]
			// },
			//NEW FORM → redirect to unified view
			{
				path: 'new-order',
				redirectTo: 'order-view/new',
				pathMatch: 'full'
			},
			{
				path: 'new-order/order-detail-info',
				redirectTo: 'order-view/new/order-detail-info',
				pathMatch: 'full'
			},
			{
				path: 'new-order/order-detail-shots',
				redirectTo: 'order-view/new/order-detail-shots',
				pathMatch: 'full'
			},

			{
				path: 'style-info/:modelId',
				component: CompanyStyleDetailComponent,
				data: { title: 'Styles | Company | BasicStudios', roles: [CompanyRole.STYLES_READ] },
				canActivate: [AuthorizationGuardService]
			},
			{
				path: 'styles',
				component: CompanyStyleListComponent,
				data: { title: 'Styles | Company | BasicStudios', roles: [CompanyRole.STYLES_READ] },
				canActivate: [AuthorizationGuardService]
			},
			{
				path: 'photographers',
				component: CompanyPhotographerListComponent,
				data: { title: 'Photographers | Company | BasicStudios', roles: [CompanyRole.PHOTOGRAPHERS_READ] },
				canActivate: [AuthorizationGuardService]
			},
			{
				path: 'edit-photographer/:photographerId',
				component: CompanyPhotographerDetailComponent,
				data: { title: 'Edit Photographers | Company | BasicStudios', roles: [CompanyRole.PHOTOGRAPHERS_EDIT] },
				canActivate: [AuthorizationGuardService]
			},

			{
				path: 'templates',
				component: CompanyTemplateListComponent,
				data: { title: 'Templates | Company | BasicStudios', roles: [CompanyRole.TEMPLATES_READ] },
				canActivate: [AuthorizationGuardService]
			},
			{
				path: 'new-template',
				component: CompanyTemplateDetailComponent,
				data: { title: 'New Template | Company | BasicStudios', roles: [CompanyRole.TEMPLATES_EDIT] },
				canActivate: [AuthorizationGuardService]
			}
			// {
			// 	path: 'management',
			// 	component: ManagementComponent,
			// 	data: { title: 'Management | Photographer | BasicStudios', roles: [CompanyRole.MANAGEMENT_READ] },
			// 	canActivate: [AuthorizationGuardService]
			// },
			// {
			// 	path: 'account',
			// 	component: AccountComponent,
			// 	data: { title: 'Account | Company | BasicStudios', roles: [CompanyRole.ACCOUNT_READ] },
			// 	canActivate: [AuthorizationGuardService]
			// },
			// {
			// 	path: 'settings',
			// 	component: SettingsComponent,
			// 	data: { title: 'Account | Company | BasicStudios' },
			// 	canActivate: [AuthorizationGuardService]
			// }
		]
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)]
})
export class CompanyRouting {}
